//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//

import type { AccountUuid, Class, Doc, IntegrationKind, Ref } from '@hcengineering/core'
import type { Asset, IntlString, Plugin } from '@hcengineering/platform'
import { plugin } from '@hcengineering/platform'
import type { Handler, IntegrationType } from '@hcengineering/setting'
import type { AnyComponent } from '@hcengineering/ui'

/** @public */
export const wechatWorkId = 'wechat-work' as Plugin

/** @public */
export const wechatWorkIntegrationKind = 'wechat-work' as IntegrationKind

/**
 * Subscription record stored per workspace per user, holding the bound
 * WeCom (Enterprise WeChat) bot webhook URL and runtime metadata.
 * @public
 */
export interface WechatWorkSubscription extends Doc {
  user: AccountUuid
  webhookUrl: string
  enabled: boolean
  lastSentOn?: number
  lastError?: string
}

export default plugin(wechatWorkId, {
  integrationType: {
    WechatWork: '' as Ref<IntegrationType>
  },
  class: {
    WechatWorkSubscription: '' as Ref<Class<WechatWorkSubscription>>
  },
  component: {
    Connect: '' as AnyComponent,
    Configure: '' as AnyComponent,
    IconWechatWork: '' as AnyComponent
  },
  icon: {
    WechatWork: '' as Asset
  },
  string: {
    WechatWork: '' as IntlString,
    IntegrationLabel: '' as IntlString,
    IntegrationDescription: '' as IntlString,
    Connect: '' as IntlString,
    Cancel: '' as IntlString,
    Save: '' as IntlString,
    Disconnect: '' as IntlString,
    WebhookUrl: '' as IntlString,
    WebhookUrlPlaceholder: '' as IntlString,
    WebhookUrlHint: '' as IntlString,
    InvalidWebhookUrl: '' as IntlString,
    Enabled: '' as IntlString,
    LastError: '' as IntlString,
    TestConnection: '' as IntlString,
    TestSuccess: '' as IntlString,
    TestFailed: '' as IntlString,
    NotConfigured: '' as IntlString,
    Configured: '' as IntlString
  },
  handler: {
    DisconnectHandler: '' as Handler,
    DisconnectAllHandler: '' as Handler
  }
})
